module.exports = __webpack_public_path__ + "static/media/scalpel-path.9f05d4f7.svg";